<template>
  <div class="tender-notice" ref="$tenderNotice" @scroll="getViewportTitle">
    <tender-chapter v-for="(chapter, i) in chapters" :key="i" :ref="setChapterRef" :chapter-index="i"></tender-chapter>
    <bear-report-to-ctba v-if="reportToCTBA" ref="bearReportToCTBA"></bear-report-to-ctba>
    <bear-report-to-province v-if="reportToProvince" ref="bearReportToProvince"></bear-report-to-province>
    <bear-electronic-mail v-if="electronicMail" ref="bearElectronicMail"></bear-electronic-mail>
    <bear-points-collection ref="bearPointsCollection"></bear-points-collection>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import hooks from "../js/hooks";
import utils from "../js/utils";
import BearElectronicMail from "~@/electronic-mail/src";
import BearTrafficElectronicMail from "~@/traffic-electronic-mail/src";
import BearReportToCtba from "~@/report-to-ctba/src";
import BearReportToProvince from "~@/report-to-province/src";
import TenderChapter from "./tender-chapter";
export default {
  name: "TenderNotice",
  components: {
    BearElectronicMail,
    BearTrafficElectronicMail,
    BearReportToCtba,
    BearReportToProvince,
    TenderChapter,
  },
  computed: {
    ...mapState(["scrollToId", "modules", "isTraffic"]),
    ...mapGetters(["chapters"]),
    electronicMail() {
      return this.modules.electronicMail;
    },
    reportToCTBA() {
      return this.modules.reportToCTBA;
    },
    reportToProvince() {
      return this.modules.reportToProvince;
    },
  },
  data() {
    return {
      mtv: null,
      chapterRefs: [],
    };
  },
  mounted() {
    this.init();
  },
  beforeUpdate() {
    this.chapterRefs = [];
  },
  methods: {
    init() {
      this.setVm(this);
      this.setValidatorCount();
    },
    ...mapMutations(["setTenderMenuOn", "setVm", "setScrollToId"]),
    ...mapActions(["setValidatorCount"]),
    getViewportTitle() {
      utils.getViewportTitle((on) => {
        clearTimeout(this.mtv);
        this.mtv = setTimeout(() => {
          this.setTenderMenuOn(on);
          this.setScrollToId("");
        }, 100);
      }, this.$refs.$tenderNotice);
    },
    scrollToFormItem(fnSuccess, fnFail, errorLevel = '') {
      let { $tenderNotice } = this.$refs;
      let tenderFormLabels = $tenderNotice.getElementsByClassName(errorLevel || "tender-form-label");
      let length = tenderFormLabels.length;
      let validRes = true;
      for (let i = 0; i < length; i++) {
        let { className } = tenderFormLabels[i];
        if (className.indexOf("is-error") >= 0) {
          this.scrollToTarget(tenderFormLabels[i]);
          validRes = false;
          fnFail && fnFail();
          break;
        }
      }
      validRes && fnSuccess && fnSuccess();
    },
    scrollToTarget($target) {
      let { $tenderNotice } = this.$refs;
      // console.log('😁😁', $tenderNotice, $target, $target.offsetTop - 50)
      utils.scrollToTop($tenderNotice, $target.offsetTop - 50);
    },
    async validate(resolve, reject) {
      let promises = this.chapterRefs.map((chapter) => chapter.validate());
      let validRes = await Promise.all(promises);
      let res = hooks.getValidateResult(validRes);
      if (res) resolve();
      else reject();
    },
    validModule(md) {
      let $md = null;
      switch (md) {
        case "reportToCTBA":
          $md = this.$refs.bearReportToCtba;
          break;
        case "reportToProvince":
          $md = this.$refs.bearReportToProvince;
          break;
        case "electronicMail":
          $md = this.$refs.bearElectronicMail;
          break;
      }
      return $md.validate();
    },
    setChapterRef(el) {
      if (el) {
        this.chapterRefs.push(el);
      }
    },
    initPointCollection(json) {
      this.$refs.bearPointsCollection.init(json)
    }
  },
  watch: {
    scrollToId(value) {
      if (value) {
        let { $tenderNotice } = this.$refs;
        let $target = $tenderNotice.getElementsByClassName(value)[0];
        // console.log($target);
        this.scrollToTarget($target);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.tender-notice {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: auto;
  padding: 0px 10px 0 15px;
  background: #f1f2f7;
}
</style>